import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=5c87b264&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=5c87b264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c87b264",
  null
  
)

export default component.exports